// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "5e3fcbca" : chunkId) + "." + {"53":"8185dc2408029bbd","335":"6c3fd107df600cb0"}[chunkId] + ".js";
};